export const defaultEnvironments = ['ProdEnv', 'OnbEnv'];
